import { User } from "../../../../../mp-database"
import { Roles } from "../../../../../mp-utils/generic-utils"
import { OrgRefScope } from "../../../../../../types/gqlTypes/graphql"
import {
  DefaultProgramLoadingType,
  DefaultProgramReducerActionType
} from "./types"

export const initialDefaultProgramLoading = {
  saving: false,
  fetching: false
}

export const ROLES_WITH_DEFAULT_PROGRAM = [
  Roles.District_Admin,
  Roles.School_Admin,
  Roles.Teacher,
  Roles.Student
]

export const defaultProgramReducer = (
  state: DefaultProgramLoadingType,
  action: DefaultProgramReducerActionType
) => {
  switch (action) {
    case "startSaving":
      return { ...state, saving: true }
    case "stopSaving":
      return { ...state, saving: false }
    case "startFetching":
      return { ...state, fetching: true }
    case "stopFetching":
      return { ...state, fetching: false }
    default:
      throw new Error("Unknown action")
  }
}

export const getOrgRefScope = (user: User): OrgRefScope => {
  return !!user
    ? {
        districtId: user.schoolDistrict,
        schoolId: user.school,
        scope: "DISTRICT"
      }
    : null
}
